<template>
  <FaIcon :icon="['fas', SCHEDULE_DEFAULT_ICON]" />
</template>

<script setup lang="ts">
import { SCHEDULE_DEFAULT_ICON } from '@/constants/schedule'
</script>
